import * as BasicShadow from './BasicShadow';

export const SHADOW_XS = BasicShadow.XS;
export const SHADOW_SM = BasicShadow.SM;
export const SHADOW_BASE = BasicShadow.BASE;
export const SHADOW_MD = BasicShadow.MD;
export const SHADOW_LG = BasicShadow.LG;
export const SHADOW_XL = BasicShadow.XL;
export const SHADOW_2XL = BasicShadow.XXL;
export const SHADOW_3XL = BasicShadow.XXXL;
export const SHADOW_OUTLINE = BasicShadow.OUTLINE;
export const SHADOW_INNER = BasicShadow.INNER;
export const SHADOW_NONE = BasicShadow.NONE;

const GenericShadow = {
    SHADOW_XS,
    SHADOW_SM,
    SHADOW_BASE,
    SHADOW_MD,
    SHADOW_LG,
    SHADOW_XL,
    SHADOW_2XL,
    SHADOW_3XL,
    SHADOW_OUTLINE,
    SHADOW_INNER,
    SHADOW_NONE,
};

export default GenericShadow;
